import * as types from "../constants/ActionTypes";
import * as entities from "../constants/Entities";
import * as lists from "../constants/Lists";
import { history } from "../history";

import {
  fetchApi,
  postApi,
  putApi,
  deleteApi,
  dispatchApiCall,
  serializeQueryString,
} from "./helpers";

// -----------------------------------------------------------------------------
// Session Identify
// -----------------------------------------------------------------------------

export function identifyUser() {
  return (dispatch) => {
    const user = fetchApi("/api/auth/identify");

    return dispatchApiCall(dispatch, user, {
      success: types.AUTH_IDENTIFY_SUCCESS,
      failure: types.AUTH_IDENTIFY_FAILURE,
    });
  };
}

export function setClientIndex(index) {
  return {
    type: types.SET_CLIENT_INDEX,
    index,
  };
}

// -----------------------------------------------------------------------------
// Email List w/ Filters
// -----------------------------------------------------------------------------

export function emailsList(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const pagination = getState().pagination.emails || {};
    const pageCount = pagination.pageCount || 0;

    if (reset || pageCount == 0) {
      emailsListNext(accountId, filters, reset)(dispatch, getState);
    }
  };
}

export function emailsListNext(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const list = lists.EMAILS;
    const pagination = getState().pagination[list] || {};
    const pageCount = pagination.pageCount || 0;
    const nextPageUrl = pagination.nextPageUrl;

    // If reached last page then don't do anything
    if (!reset && pageCount > 0 && !nextPageUrl) {
      return null;
    }

    // Build fetch promise
    const fetchUrl =
      (!reset && pagination.nextPageUrl) ||
      "/api/clients/" + accountId + "/emails?" + serializeQueryString(filters);
    const listPages = fetchApi(fetchUrl);

    dispatchApiCall(dispatch, listPages, {
      request: types.EMAILS_REQUEST,
      success: types.EMAILS_SUCCESS,
      failure: types.EMAILS_FAILURE,
      entity: entities.EMAIL,
      list,
      filters,
      reset,
    });
  };
}

export function emailsListClear() {
  return {
    type: types.EMAILS_SUCCESS,
    entity: entities.EMAIL,
    list: lists.EMAILS,
    data: [],
    reset: true,
  };
}

// -----------------------------------------------------------------------------
// Email Modules List w/ Filters
// -----------------------------------------------------------------------------

export function emailModulesList(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const pagination = getState().pagination.emailModules || {};
    const pageCount = pagination.pageCount || 0;

    if (reset || pageCount == 0) {
      emailModulesListNext(accountId, filters, reset)(dispatch, getState);
    }
  };
}

export function emailModulesListNext(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const list = lists.EMAIL_MODULES;
    const pagination = getState().pagination[list] || {};
    const pageCount = pagination.pageCount || 0;
    const nextPageUrl = pagination.nextPageUrl;

    // If reached last page then don't do anything
    if (!reset && pageCount > 0 && !nextPageUrl) {
      return null;
    }

    // Build fetch promise
    const fetchUrl =
      (!reset && pagination.nextPageUrl) ||
      "/api/clients/" +
      accountId +
      "/email-modules?" +
      serializeQueryString(filters);
    const listPages = fetchApi(fetchUrl);

    dispatchApiCall(dispatch, listPages, {
      request: types.EMAIL_MODULES_REQUEST,
      success: types.EMAIL_MODULES_SUCCESS,
      failure: types.EMAIL_MODULES_FAILURE,
      entity: entities.EMAIL_MODULE,
      list,
      filters,
      reset,
    });
  };
}

// -----------------------------------------------------------------------------
// Email Modules List w/ Filters
// -----------------------------------------------------------------------------

export function emailTemplatesList(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const pagination = getState().pagination.emailTemplates || {};
    const pageCount = pagination.pageCount || 0;

    if (reset || pageCount == 0) {
      emailTemplatesListNext(accountId, filters, reset)(dispatch, getState);
    }
  };
}

export function emailTemplatesListNext(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const list = lists.EMAIL_TEMPLATES;
    const pagination = getState().pagination[list] || {};
    const pageCount = pagination.pageCount || 0;
    const nextPageUrl = pagination.nextPageUrl;

    // If reached last page then don't do anything
    if (!reset && pageCount > 0 && !nextPageUrl) {
      return null;
    }

    // Build fetch promise
    const fetchUrl =
      (!reset && pagination.nextPageUrl) ||
      "/api/clients/" +
      accountId +
      "/email-templates?" +
      serializeQueryString(filters);
    const listPages = fetchApi(fetchUrl);

    dispatchApiCall(dispatch, listPages, {
      request: types.EMAIL_TEMPLATES_REQUEST,
      success: types.EMAIL_TEMPLATES_SUCCESS,
      failure: types.EMAIL_TEMPLATES_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
      list,
      filters,
      reset,
    });
  };
}

// -----------------------------------------------------------------------------
// Template Editor
// -----------------------------------------------------------------------------

export function updateEditTemplateNameValue(value) {
  return {
    type: types.EMAIL_TEMPLATE_UPDATE_NAME_VALUE,
    value,
  };
}

export function fetchEmailTemplate(accountId, id) {
  return (dispatch) => {
    const data = fetchApi(
      "/api/clients/" + accountId + "/email-templates/" + id
    );

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_TEMPLATE_REQUEST,
      success: types.EMAIL_TEMPLATE_SUCCESS,
      failure: types.EMAIL_TEMPLATE_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
    });
  };
}

export function emailTemplateSetKeyValue(key, value) {
  return {
    type: types.EMAIL_TEMPLATE_SET_KEY_VALUE,
    key,
    value,
  };
}

export function updateEmailTemplate(accountId, id, emailTemplate) {
  return (dispatch) => {
    const data = putApi(
      "/api/clients/" + accountId + "/email-templates/" + id,
      emailTemplate
    );

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_TEMPLATE_UPDATE_REQUEST,
      success: types.EMAIL_TEMPLATE_UPDATE_SUCCESS,
      failure: types.EMAIL_TEMPLATE_UPDATE_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
    });
  };
}

export function createEmailTemplate(accountId, email) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/email-templates/",
      email
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_TEMPLATE_REQUEST,
      success: types.EMAIL_TEMPLATE_SUCCESS,
      failure: types.EMAIL_TEMPLATE_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
    });
  };
}

export function cloneEmailTemplate(accountId, id, email) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/email-templates/" + id + "/clone",
      email
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_TEMPLATE_REQUEST,
      success: types.EMAIL_TEMPLATE_SUCCESS,
      failure: types.EMAIL_TEMPLATE_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
    });
  };
}

export function deleteEmailTemplate(accountId, id, email) {
  return (dispatch) => {
    const data = deleteApi(
      "/api/clients/" + accountId + "/email-templates/" + id
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_TEMPLATE_REQUEST,
      success: types.EMAIL_TEMPLATE_SUCCESS,
      failure: types.EMAIL_TEMPLATE_FAILURE,
      entity: entities.EMAIL_TEMPLATE,
      remove: true,
    });
  };
}

export function gotoUrl(url) {
  return (dispatch) => {
    history.push(url);
  };
}

// -----------------------------------------------------------------------------
// Module Editor
// -----------------------------------------------------------------------------

export function updateEditModuleNameValue(value) {
  return {
    type: types.EMAIL_MODULE_UPDATE_NAME_VALUE,
    value,
  };
}

export function toggleEditModuleHtml() {
  return {
    type: types.EDIT_MODULE_TOGGLE_HTML,
  };
}

export function toggleEditModuleCss() {
  return {
    type: types.EDIT_MODULE_TOGGLE_CSS,
  };
}

export function toggleEditModuleData() {
  return {
    type: types.EDIT_MODULE_TOGGLE_DATA,
  };
}

export function toggleEditModuleTemplate() {
  return {
    type: types.EDIT_MODULE_TOGGLE_TEMPLATE,
  };
}

export function toggleEditModulePreview() {
  return {
    type: types.EDIT_MODULE_TOGGLE_PREVIEW,
  };
}

export function toggleEditModuleImagePicker() {
  return {
    type: types.EDIT_MODULE_TOGGLE_IMAGEPICKER,
  };
}

export function emailModuleSetKeyValue(key, value) {
  return {
    type: types.EMAIL_MODULE_SET_KEY_VALUE,
    key,
    value,
  };
}

export function updateEmailModule(accountId, id, emailModule) {
  return (dispatch) => {
    const data = putApi(
      "/api/clients/" + accountId + "/email-modules/" + id,
      emailModule
    );

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_UPDATE_REQUEST,
      success: types.EMAIL_MODULE_UPDATE_SUCCESS,
      failure: types.EMAIL_MODULE_UPDATE_FAILURE,
      entity: entities.EMAIL_MODULE,
    });
  };
}

// -----------------------------------------------------------------------------
// Switch Email View Type
// -----------------------------------------------------------------------------

export function setEditorDisplayWidth(width) {
  return {
    type: types.EDITOR_SET_DISPLAY_WIDTH,
    width,
  };
}

export function toggleEditorBreakdown() {
  return {
    type: types.EDITOR_TOGGLE_BREAKDOWN,
  };
}

export function openEditorBreakdown() {
  return {
    type: types.EDITOR_OPEN_BREAKDOWN,
  };
}

export function switchEditorModules(from, to) {
  return {
    type: types.EDITOR_SWAP_MODULES,
    from,
    to,
  };
}

export function selectEditorModule(index) {
  return {
    type: types.EDITOR_SELECT_MODULE,
    index,
  };
}

export function updateEditorSelectedModuleFieldValue(fieldIndex, value) {
  return {
    type: types.EDITOR_UPDATE_MODULE_FIELD_VALUE,
    fieldIndex,
    value,
  };
}

export function uploadEditorSelectedModuleFieldValue(
  fieldIndex,
  accountId,
  emailId,
  data
) {
  return (dispatch) => {
    var formData = new FormData();
    formData.append("file", data);
    formData.append("emailId", emailId);
    // formData.append('test1', 'def');

    const upload = postApi("/api/clients/" + accountId + "/images", formData);

    dispatchApiCall(
      dispatch,
      upload,
      {
        request: types.IMAGE_UPLOAD_REQUEST,
        success: types.EDITOR_UPLOAD_MODULE_FIELD_VALUE,
        failure: types.IMAGE_UPLOAD_FAILURE,
      },
      {
        fieldIndex,
      }
    );
  };
}

export function updateEditorNameValue(value) {
  return {
    type: types.EDITOR_UPDATE_NAME_VALUE,
    value,
  };
}

export function updateEditorSubjectValue(value) {
  return {
    type: types.EDITOR_UPDATE_SUBJECT_VALUE,
    value,
  };
}

export function updateEditorTranslationVariation(value) {
  return {
    type: types.EDITOR_UPDATE_TRANSLATION_VARIATION,
    value,
  };
}

export function fetchEmail(accountId, id) {
  return (dispatch) => {
    const data = fetchApi("/api/clients/" + accountId + "/emails/" + id);

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_REQUEST,
      success: types.EMAIL_SUCCESS,
      failure: types.EMAIL_FAILURE,
      entity: entities.EMAIL,
    });
  };
}

export function fetchEmailHtml(accountId, id) {
  return (dispatch) => {
    const data = fetchApi(
      "/api/clients/" + accountId + "/emails/" + id + "/html",
      {
        raw: true,
      }
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_HTML_REQUEST,
      success: types.EMAIL_HTML_SUCCESS,
      failure: types.EMAIL_HTML_FAILURE,
    });
  };
}

export function createEmail(accountId, email) {
  return (dispatch) => {
    const data = postApi("/api/clients/" + accountId + "/emails/", email);

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_REQUEST,
      success: types.EMAIL_SUCCESS,
      failure: types.EMAIL_FAILURE,
      entity: entities.EMAIL,
    });
  };
}

export function cloneEmail(accountId, id, email) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/emails/" + id + "/clone",
      email
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_REQUEST,
      success: types.EMAIL_SUCCESS,
      failure: types.EMAIL_FAILURE,
      entity: entities.EMAIL,
    });
  };
}

export function updateEmail(accountId, id, email) {
  return (dispatch) => {
    const data = putApi("/api/clients/" + accountId + "/emails/" + id, email);

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_UPDATE_REQUEST,
      success: types.EMAIL_UPDATE_SUCCESS,
      failure: types.EMAIL_UPDATE_FAILURE,
      entity: entities.EMAIL,
    });
  };
}

export function deleteEmail(accountId, id) {
  return (dispatch) => {
    const data = deleteApi("/api/clients/" + accountId + "/emails/" + id);

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_REQUEST,
      success: types.EMAIL_SUCCESS,
      failure: types.EMAIL_FAILURE,
      entity: entities.EMAIL,
      remove: true,
    });
  };
}

export function sendEmail(accountId, id, emailAddress, variation) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" +
      accountId +
      "/emails/" +
      id +
      "/send?var=" +
      encodeURIComponent(variation || ""),
      {
        emailAddress,
      }
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_SEND_REQUEST,
      success: types.EMAIL_SEND_SUCCESS,
      failure: types.EMAIL_SEND_FAILURE,
    });
  };
}

export function sendEmailModule(accountId, id, emailAddress) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/email-modules/" + id + "/send",
      {
        emailAddress,
      }
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_SEND_REQUEST,
      success: types.EMAIL_SEND_SUCCESS,
      failure: types.EMAIL_SEND_FAILURE,
    });
  };
}

export function fetchModules(searchTerm) {
  return (dispatch) => {
    const url =
      "/api/email-modules" + (searchTerm ? "?name=" + searchTerm : "");
    const data = fetchApi(url);

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_REQUEST,
      success: types.EMAIL_MODULE_SUCCESS,
      failure: types.EMAIL_MODULE_FAILURE,
      entity: entities.EMAIL_MODULE,
      list: lists.EMAIL_MODULES,
      reset: true,
    });
  };
}

export function fetchModule(accountId, id) {
  return (dispatch) => {
    const data = fetchApi("/api/clients/" + accountId + "/email-modules/" + id);

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_REQUEST,
      success: types.EMAIL_MODULE_SUCCESS,
      failure: types.EMAIL_MODULE_FAILURE,
      entity: entities.EMAIL_MODULE,
    });
  };
}

export function insertModule(accountId, id, index) {
  return (dispatch) => {
    const data = fetchApi("/api/clients/" + accountId + "/email-modules/" + id);

    dispatchApiCall(
      dispatch,
      data,
      {
        request: types.EDITOR_INSERT_MODULE_REQUEST,
        success: types.EDITOR_INSERT_MODULE_SUCCESS,
        failure: types.EDITOR_INSERT_MODULE_FAILURE,
        entity: entities.EMAIL_MODULE,
      },
      {
        index,
      }
    );
  };
}

export function createEmailModule(accountId, email) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/email-modules/",
      email
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_REQUEST,
      success: types.EMAIL_MODULE_SUCCESS,
      failure: types.EMAIL_MODULE_FAILURE,
      entity: entities.EMAIL_MODULE,
    });
  };
}

export function cloneEmailModule(accountId, id, email) {
  return (dispatch) => {
    const data = postApi(
      "/api/clients/" + accountId + "/email-modules/" + id + "/clone",
      email
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_REQUEST,
      success: types.EMAIL_MODULE_SUCCESS,
      failure: types.EMAIL_MODULE_FAILURE,
      entity: entities.EMAIL_MODULE,
    });
  };
}

export function deleteEmailModule(accountId, id) {
  return (dispatch) => {
    const data = deleteApi(
      "/api/clients/" + accountId + "/email-modules/" + id
    );

    return dispatchApiCall(dispatch, data, {
      request: types.EMAIL_MODULE_REQUEST,
      success: types.EMAIL_MODULE_SUCCESS,
      failure: types.EMAIL_MODULE_FAILURE,
      entity: entities.EMAIL_MODULE,
      remove: true,
    });
  };
}

export function removeSelectedModule() {
  return {
    type: types.EDITOR_REMOVE_SELECTED_MODULE,
  };
}

export function uploadEmailTranslations(accountId, id, data) {
  return (dispatch) => {
    var formData = new FormData();
    formData.append("file", data);

    const upload = postApi(
      "/api/clients/" + accountId + "/emails/" + id + "/translations",
      formData
    );

    dispatchApiCall(dispatch, upload, {
      request: types.EMAIL_UPLOAD_TRANSLATIONS_REQUEST,
      success: types.EMAIL_UPLOAD_TRANSLATIONS_SUCCESS,
      failure: types.EMAIL_UPLOAD_TRANSLATIONS_FAILURE,
    });
  };
}

export function clearEmailTranslations(accountId, id) {
  return (dispatch) => {
    const data = putApi("/api/clients/" + accountId + "/emails/" + id, {
      translations: null,
    });

    dispatchApiCall(dispatch, data, {
      request: types.EMAIL_CLEAR_TRANSLATIONS_REQUEST,
      success: types.EMAIL_CLEAR_TRANSLATIONS_SUCCESS,
      failure: types.EMAIL_CLEAR_TRANSLATIONS_FAILURE,
      entity: entities.EMAIL,
    });
  };
}

// -----------------------------------------------------------------------------
// Images
// -----------------------------------------------------------------------------

export function uploadImage(accountId, data) {
  return (dispatch) => {
    var formData = new FormData();
    formData.append("file", data);

    const upload = postApi("/api/clients/" + accountId + "/images", formData);

    return dispatchApiCall(dispatch, upload, {
      request: types.IMAGE_UPLOAD_REQUEST,
      success: types.IMAGE_UPLOAD_SUCCESS,
      failure: types.IMAGE_UPLOAD_FAILURE,
    });
  };
}

export function deleteImage(accountId, id) {
  return (dispatch) => {
    const data = deleteApi("/api/clients/" + accountId + "/images/" + id);

    return dispatchApiCall(dispatch, data, {
      request: types.IMAGES_REQUEST,
      success: types.IMAGES_SUCCESS,
      failure: types.IMAGES_FAILURE,
      entity: entities.IMAGE,
      remove: true,
    });
  };
}

// -----------------------------------------------------------------------------
// Image List w/ Filters
// -----------------------------------------------------------------------------

export function imagesList(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const pagination = getState().pagination.images || {};
    const pageCount = pagination.pageCount || 0;

    if (reset || pageCount == 0) {
      imagesListNext(accountId, filters, reset)(dispatch, getState);
    }
  };
}

export function imagesListNext(accountId, filters, reset = false) {
  return (dispatch, getState) => {
    const list = lists.IMAGES;
    const pagination = getState().pagination[list] || {};
    const pageCount = pagination.pageCount || 0;
    const nextPageUrl = pagination.nextPageUrl;

    // If reached last page then don't do anything
    if (!reset && pageCount > 0 && !nextPageUrl) {
      return null;
    }

    // Build fetch promise
    const fetchUrl =
      (!reset && pagination.nextPageUrl) ||
      "/api/clients/" + accountId + "/images?" + serializeQueryString(filters);
    const listPages = fetchApi(fetchUrl);

    dispatchApiCall(dispatch, listPages, {
      request: types.IMAGES_REQUEST,
      success: types.IMAGES_SUCCESS,
      failure: types.IMAGES_FAILURE,
      entity: entities.IMAGE,
      list,
      filters,
      reset,
    });
  };
}

// -----------------------------------------------------------------------------
// Open Modal
// -----------------------------------------------------------------------------

export function openModal(path, params) {
  return {
    type: types.OPEN_MODAL,
    path,
    params,
  };
}

export function closeModal() {
  return {
    type: types.CLOSE_MODAL,
  };
}

// -----------------------------------------------------------------------------
// QA
// -----------------------------------------------------------------------------

export function qaFlushTests() {
  return {
    type: types.QA_FLUSH_TESTS,
  };
}

export function qaRegisterTest(name) {
  return {
    type: types.QA_REGISTER_TEST,
    name,
  };
}

export function qaTestPass(name) {
  return {
    type: types.QA_TEST_PASS,
    name,
  };
}

export function qaTestFail(name, data) {
  return {
    type: types.QA_TEST_FAIL,
    name,
    data,
  };
}

// -----------------------------------------------------------------------------
// QA Email
// -----------------------------------------------------------------------------

export function fetchEmailQA(accountId, id) {
  return (dispatch) => {
    const data = fetchApi(
      "/api/clients/" + accountId + "/emails/" + id + "/qa"
    );

    return dispatchApiCall(dispatch, data, {
      request: types.QA_REQUEST,
      success: types.QA_SUCCESS,
      failure: types.QA_FAILURE,
    });
  };
}

export function downloadEmail(accountId, id, absoluteUrls = false) {
  window.location = `${process.env.REACT_APP_API_ENDPOINT
    }/api/clients/${accountId}/emails/${id}/download${absoluteUrls ? "?absoluteUrls=true" : ""
    }`;
  return {
    type: types.EMAIL_DOWNLOAD,
  };
}

// -----------------------------------------------------------------------------
// Campaign List w/ Filters
// -----------------------------------------------------------------------------

export function campaignsList(
  accountId,
  filters,
  subList = false,
  reset = false
) {
  return (dispatch, getState) => {
    const pagination = getState().pagination.campaigns || {};
    const pageCount = pagination.pageCount || 0;

    if (reset || pageCount == 0) {
      campaignsListNext(accountId, filters, subList, reset)(dispatch, getState);
    }
  };
}

export function campaignsListNext(
  accountId,
  filters,
  subList = false,
  reset = false
) {
  return (dispatch, getState) => {
    const list = subList ? lists.CAMPAIGNS_BY_PARENT : lists.CAMPAIGNS;
    const pagination = getState().pagination[list] || {};
    const pageCount = pagination.pageCount || 0;
    const nextPageUrl = pagination.nextPageUrl;

    // If reached last page then don't do anything
    if (!reset && pageCount > 0 && !nextPageUrl) {
      return null;
    }

    // Build fetch promise
    const fetchUrl =
      (!reset && pagination.nextPageUrl) ||
      "/api/clients/" +
      accountId +
      "/campaigns?" +
      serializeQueryString(filters);
    const listPages = fetchApi(fetchUrl);

    dispatchApiCall(dispatch, listPages, {
      request: types.CAMPAIGN_REQUEST,
      success: types.CAMPAIGN_SUCCESS,
      failure: types.CAMPAIGN_FAILURE,
      entity: entities.CAMPAIGN,
      list,
      filters,
      reset,
      subList,
    });
  };
}

export function fetchCampaign(accountId, id) {
  return (dispatch) => {
    const data = fetchApi("/api/clients/" + accountId + "/campaigns/" + id);

    return dispatchApiCall(dispatch, data, {
      request: types.CAMPAIGN_REQUEST,
      success: types.CAMPAIGN_SUCCESS,
      failure: types.CAMPAIGN_FAILURE,
      entity: entities.CAMPAIGN,
    });
  };
}

export function createCampaign(accountId, campaign) {
  return (dispatch) => {
    const data = postApi("/api/clients/" + accountId + "/campaigns/", campaign);

    return dispatchApiCall(dispatch, data, {
      request: types.CAMPAIGN_REQUEST,
      success: types.CAMPAIGN_SUCCESS,
      failure: types.CAMPAIGN_FAILURE,
      entity: entities.CAMPAIGN,
    });
  };
}

export function updateCampaign(accountId, id, campaign) {
  return (dispatch) => {
    const data = putApi(
      "/api/clients/" + accountId + "/campaigns/" + id,
      campaign
    );

    dispatchApiCall(dispatch, data, {
      request: types.CAMPAIGN_REQUEST,
      success: types.CAMPAIGN_SUCCESS,
      failure: types.CAMPAIGN_FAILURE,
      entity: entities.CAMPAIGN,
    });
  };
}

export function deleteCampaign(accountId, id) {
  return (dispatch) => {
    const data = deleteApi("/api/clients/" + accountId + "/campaigns/" + id);

    return dispatchApiCall(dispatch, data, {
      request: types.CAMPAIGN_REQUEST,
      success: types.CAMPAIGN_SUCCESS,
      failure: types.CAMPAIGN_FAILURE,
      entity: entities.CAMPAIGN,
      remove: true,
    });
  };
}
